
   export var config = {
    baseUrl: "https://lsraheja.etranscript.in/",
    serverUrl : "https://lsraheja.etranscript.in",
    socketioUrl : "http://192.168.90.207:5007",
    ENV_sendgrid_Twilio : "production",
    transUploadUrl:"https://lsraheja.etranscript.in/api/attestation/upload_document",
    markListUploadUrl_ : "https://lsraheja.etranscript.in/api/attestation/uploadMarkList",
    markListUploadUrl : "https://lsraheja.etranscript.in/api/attestation/uploadUserMarkList",
    docUploadUrl :  "https://lsraheja.etranscript.in/api/etranscript/upload_doc",
    curriculumUploadUrl: "http://localhost:3535/api/attestation/upload_curriculum",
    siteKey : "6Lc3ptodAAAAAFJYTrnNN_ynEcUa2vjSOfbNmk9R"
  }
